export default {
	UPDATE_USERSTATUS: "UPDATE_USERSTATUS",
	ADD_USER_DATA: "ADD_USER_DATA",
	SAVE_USER_DATA: "SAVE_USER_DATA",
	SAVE_USER_PROFILE: "SAVE_USER_PROFILE",
	RESET_USERSTATUS: "RESET_USERSTATUS"
};
